import { routes } from './routes';

export {
    routes,
};

export default {
    routes,
};
